import Repository from "./repository"

export default {
    /**
     * 画面表示前初期処理
     * @returns response
     */
    get() {
        return Repository.get("/api/c205-header-info/get")
    },
}